module.exports = __webpack_public_path__ + "static/media/lelievre.d3256717.png";